<template>
  <div>
    <v-navigation-drawer
      v-model="editTicketDrawer"
      class="px-6 pt-6 overflow-y-hidden pr-2"
      id="filter-ticket-drawer"
      width="550px"
      right
      fixed
      temporary
    >
      <div class="mb-5 fixed-drawer pr-8 pl-2">
        <v-row no-gutters>
          <v-col align="left" cols="auto">
            <h5
              class="
                text-h5
                font-weight-600
                float-left
                text-capitalize
              "
            >
              <span class="secondary--font"> Edit Ticket Details </span>
            </h5>
          </v-col>
          <v-col align="right">
            <v-btn
              icon
              @click.stop="editTicketDrawer = false"
              class="float-right"
              v-track="'close-edit-drawer'"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-card elevation="0">
          <v-form class="mt-5" v-model="valid" ref="updateticket">
            <v-card-text class="px-0">
              <v-text-field
                v-model="subject"
                label="Subject"
                class="required text-field"
                outlined
                required
                :rules="[(v) => !!v || 'Subject is required']"
              ></v-text-field>

              <v-input
                name="hidden-description"
                outlined
                label="Description"
                class="required mt-5"
                type="hidden"
                required
                v-model="description"
                :rules="[(v) => !!v || 'Description is required']"
              ></v-input>

              <v-card height="230" outlined class="mb-8 overflow-auto">
                <CKEditor
                  v-if="description !== null"
                  @update="description = $event"
                  :body="description"
                  :key="loadCKeditor"
                >
                </CKEditor>
              </v-card>

              <ContactsField
                page="edit"
                v-if="editTicketDrawer"
                :selectedContact="selectedContact"
                :key="loadComponent + 'A'"
                @getValue="selectedContact = $event"
              ></ContactsField>
              <!-- <ParentTicket
                page="edit"
                :parentTicket="parentTicket"
                :key="loadComponent"
                @getValue="parentTicket = $event"
              ></ParentTicket> -->
              <v-row>
                <v-col
                  cols="12"
                  class="pb-0"
                  v-if="attachmentFiles.length || dropedFiles.length"
                >
                  <h6 class="text-subtitle-1">
                    <span class="secondary--font font-weight-600">
                      Attachments ({{
                        attachmentFiles.length + dropedFiles.length
                      }})
                    </span>
                  </h6>
                </v-col>
                <v-col cols="12" v-if="attachmentFiles.length">
                  <template v-for="(file, index) in attachmentFiles">
                    <v-chip
                      color="#CBDAE8"
                      :key="index"
                      class="ml-0 ma-2 mr-3"
                      close
                      @click:close="removeAttchment(file, 'old')"
                    >
                      <span class="text-truncate" style="max-width: 300px">
                        {{ file.file_name }}
                      </span>
                    </v-chip>
                  </template>
                </v-col>
                <v-col cols="12" class="pt-0" v-if="dropedFiles.length">
                  <template v-for="(file, index) in dropedFiles">
                    <v-chip
                      color="#CBDAE8"
                      :key="index"
                      class="ml-0 ma-2 mr-3"
                      close
                      @click:close="removeAttchment(file, 'new')"
                    >
                      <span class="text-truncate" style="max-width: 300px"
                        >{{ file.name }}
                      </span>
                    </v-chip>
                  </template>
                </v-col>
                <v-col cols="12">
                  <v-btn
                    outlined
                    class="font-weight-bold"
                    @click="handleFileImport"
                    v-track="'attach-file-import-btn'"
                  >
                    <v-icon> mdi-plus </v-icon>
                    Attach File
                  </v-btn>
                  <!-- Create a File Input that will be hidden but triggered with JavaScript -->
                  <input
                    ref="uploader"
                    class="d-none"
                    type="file"
                    multiple="multiple"
                    @change="onFileChanged"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-form>
        </v-card>
      </div>
      <template v-slot:append>
        <div class="pa-2">
          <v-card-actions class="px-0 d-flex align-end">
            <v-btn
              class="font-weight-bold mb-4"
              v-track="'cancel-ticket-edit-action'"
              outlined
              @click.stop="editTicketDrawer = false"
              >Cancel</v-btn
            >
            <v-btn
              id="apply-filter"
              :disabled="!valid"
              :dark="valid"
              class="font-weight-bold mb-4"
              @click="updateTicket()"
              v-track="'update-ticket'"
              >Save</v-btn
            >
          </v-card-actions>
        </div>
      </template>
    </v-navigation-drawer>
  </div>
</template>
<script>
import { $tickets } from "@/services/Index";
import { uploadfileMixin } from "@/mixins/uploadfile.js";
//import ParentTicket from "@/components/tickets/ParentTicket";
import ContactsField from "./ContactsField";
import { attachmentfileactionMixin } from "@/mixins/attachmentFileAction.js";
import CKEditor from "@/components/ckeditor/Editor";

export default {
  name: "edit-ticket-drawer",
  mixins: [uploadfileMixin, attachmentfileactionMixin],
  components: {
    //ParentTicket,
    ContactsField,
    CKEditor,
  },
  props: {
    ticketDetails: {
      type: Object,
      default: () => {},
    },
    showDrawer: Boolean,
  },
  data() {
    return {
      valid: true,
      editTicketDrawer: false,
      filterCounter: 0,
      loadComponent: false,
      selectedContact: null,
      subject: null,
      description: null,
      attachmentFiles: [],
      deleteAttachmentIds: [],
      dropedFiles: [],
      parentTicket: "",
      loadCKeditor: false,
      tagsID:[],
    };
  },

  mounted() {
    if (this.showDrawer) {
      this.toggleDrawer();
    }
  },
  methods: {
    /* clear all the selected date on click of cancel button */
    // clearSelectedDates() {
    //   this.menu = false;
    //   console.log("length check",this.dates.length);
    //   if (this.dates.length !== 0) {
    //     this.dates = [];
    //   }
    // },

    /** onclick of pencil icon showing drawer with selected ticket  data */
    toggleDrawer() {
      this.$refs.updateticket.resetValidation();
      this.subject = this.ticketDetails.subject;
      this.description = this.ticketDetails.description;
      this.attachmentFiles = this.ticketDetails.attachment_info;
      if (this.ticketDetails.parent_ticket_id) {
        this.parentTicket = this.ticketDetails.parent_ticket_id;
      } else {
        this.parentTicket = "";
      }
      if (this.ticketDetails.contact_id) {
        this.selectedContact = this.ticketDetails.contact_id;
      } else {
        this.selectedContact = null;
      }
      this.editTicketDrawer = true;
      this.loadComponent = !this.loadComponent;
    },

    /** updateTicket update API request. */
    async updateTicket() {
      this.$refs.updateticket.validate();
      let ticketId = this.ticketDetails.id;
      let config = {};
      let data = {
        ticket: {
          subject: this.subject,
          description: this.description,
          delete_attachment_ids: this.deleteAttachmentIds,
          parent_ticket_id: this.parentTicket,
          contact_id: this.selectedContact,
        },
      };
      if (this.$refs.updateticket.validate()) {
        let payload = null;
        payload = data;
        const formdata = new FormData();
        if (this.dropedFiles.length) {
          config = {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          };
          let ticketdata = data.ticket;
          for (var key in ticketdata) {
            if (key == "delete_attachment_ids") {
              ticketdata[key].forEach((item) => {
                formdata.append("delete_attachment_ids[]", item);
              });
            } else {
                formdata.append(key, ticketdata[key]);
            }
          }
          this.dropedFiles.forEach((file) => {
            formdata.append("attachments[]", file);
          });
          payload = formdata;
        }
        try {
          const response = await $tickets.update(payload, ticketId, config);
          if (response.data) {
            this.$emit("reloadTicket");
            this.editTicketDrawer = false;
            this.dropedFiles = [];
            this.deleteAttachmentIds = [];
            this.$store.dispatch("ui/snackbar", [
              {
                title: "",
                message: `Ticket Updated`,
                type: "success",
              },
            ]);
          }
        } catch (error) {
          this.editTicketDrawer = false;
          this.dropedFiles = [];
          this.deleteAttachmentIds = [];

          if (error.response !== undefined) {
            this.$store.dispatch("ui/snackbar", [
              {
                title: "Error",
                message: this.$errors(error.response.data).msg({
                  capitalize: false,
                  prepend: `${this.$errors(
                    error.response.data
                  ).subjectText()} `,
                }),
                type: "error",
              },
            ]);
          }
        }
      }
    },
  },
};
</script>

<style></style>
